import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconLogin } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../../../global-config'
import { urlResolverGetLogin } from '../../../../../../url-handling'

export const HeaderLoginButton: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="mb-4">
      <Button<'a'>
        className="w-full"
        endIcon={<IconLogin />}
        href={urlResolverGetLogin(globalConfig)}
        size="large"
        slots={{ root: 'a' }}
        variant="filled"
      >
        <FormattedMessage id="general.link.label.login" />
      </Button>
    </div>
  )
}
